import { BridgeFiatRail } from 'services/merchants/types';

import { DataTableCellProps, TableCell } from 'components/dataTable';

import { capitalizeFirstLetter } from 'utils/string';

import { KEYS } from './keys';

export const PaymentRailCell = ({ row, column }: DataTableCellProps) => {
  const value = row[column.id];

  const formattedPaymentRail = {
    [BridgeFiatRail.ACH]: 'ACH',
    [BridgeFiatRail.ACH_SAME_DATE]: 'ACH Same Day',
    [BridgeFiatRail.WIRE]: 'Wire',
    [BridgeFiatRail.SWIFT]: 'SWIFT',
    [BridgeFiatRail.SEPA]: 'SEPA',
    [BridgeFiatRail.SPEI]: 'SPEI',
    [BridgeFiatRail.PIX]: 'PIX',
    [BridgeFiatRail.BRE_B]: 'Bre-B',
  }[value as BridgeFiatRail];

  const formattedValue = value === undefined ? KEYS.VALUE_PLACEHOLDER : capitalizeFirstLetter(value?.toString()?.replace(/_/g, ' ')) ?? '-';

  return <TableCell data-column={column.id}>{formattedPaymentRail ?? formattedValue}</TableCell>;
};
